import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { SubscriptionComponentConfig, subscriptionComponentConfigInput } from "./component/SubscriptionComponentConfig";

export const sortOptions = [
	{ value: "title", label: "Name", key: "item.name" },
	{ value: "startDate", label: "Start Date", key: "item.startDate" },
	{ value: "endDate", label: "End Date", key: "item.endDate" },
	{value: "lastVisited", label: "Last Accessed", key: "lastVisited"}
];

// const sortChoices = ListOrderWidget.registerWithOptions(sortOptions, true);

@Form({title: "My Courses Config"})
export class SubscriptionsConfig {

	@Input({type: InputType.JSON, title: "Subscription Params"})
	public subscriptionParams: object;

	@Input({ type: InputType.JSON, title: "Credit Claim Params" })
	public creditClaimParams?: object;

	@Input({type: InputType.CHECKBOX, title: "Horizontal Layout"})
	public inlineLayout?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Refine"})
	public enableRefine?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Thumbnails"})
	public showThumbnail?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Progress Bar"})
	public showProgress?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Progress Text"})
	public showProgressText?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Subscription Meta Info"})
	public showSubscriptionMeta?: boolean;

	@Input({type: InputType.UNIT, title: "Thumbnail Size"})
	public thumbnailSize?: string;

	@Input({type: InputType.CHECKBOX, title: "Show load more"})
	public enableLoadMore: boolean = false;

	@Input({ type: InputType.CHECKBOX, title: "Show Table Page Size options" })
	public showTablePageSize: boolean = false;

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number;

	@Input({type: InputType.TEXT, title: "Page Size Options (Ex:4,8,12)"})
	public pageSizeOptions?: string;

	@Input({type: InputType.CHECKBOX, title: "Show View All Link"})
	public showViewAllLink: boolean = false;

	// @Input({type: sortChoices, title: "Sort Options"})
	// public sortChoices: string[];

	@Input({type: InputType.CHECKBOX, title: "Exclude Hidden Courses"})
	public excludeHidden?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show View Details Link"})
	public enableViewDetails?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable self claim credits"})
	public enableSelfClaimCredits?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable claim partial credits"})
	public enablePartialClaimCredits?: boolean;

	@Input({type: InputType.NUMBER, title: "Partial credit increments"})
	public partialCreditIncrease?: number;

	@Input({type: subscriptionComponentConfigInput, title: "Subscription Fields"})
	public subscriptionComponent?: SubscriptionComponentConfig;

	@Input({type: InputType.CHECKBOX, title: "Export"})
	public export: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Show Credit Claim Complete Button"})
	public showCreditClaimButton?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Subscription Expired Text"})
	public subscriptionExpired?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Extend Subscription Button"})
	public extendSubscription?: boolean;
	
	@Input({ type: InputType.TEXT, title: "Hide Claim Button" })
	public claimButton?: string;
}



// WEBPACK FOOTER //
// ./src/panels/subscriptions/SubscriptionsConfig.ts